export default __webpack_public_path__ + "static/media/Login.accd24de.svg";